<template>
    <div @click="$emit('emitTabChange', tab)" class="tw-cursor-pointer tw-p-6 tw-relative tw-mr-4">
        <p
            :class="['tw-text-gray-400 hover:tw-text-gray-500 tw-font-normal', { 'secondary-c tw-font-semibold': active_tab === tab }]">
            {{ text }}</p>
        <div v-if="active_tab === tab" class="active secondary-c-bg"></div>
    </div>
</template>

<script>
export default {
    name: 'Tab',
    props: ['active_tab', 'text', 'tab'],
}
</script>

<style lang="scss" scoped>
.active {
    @apply tw-block tw-absolute tw-w-full tw-bottom-0 tw-left-0 tw-h-1 tw-rounded-tl tw-rounded-tr;
}
</style> 
